export default __webpack_public_path__ + "f20dd7642c5eed8fe8596ea582693bb5.png";